import { render, staticRenderFns } from "./ExclusivesGallery.vue?vue&type=template&id=8cf1dbf0&"
import script from "./ExclusivesGallery.vue?vue&type=script&lang=js&"
export * from "./ExclusivesGallery.vue?vue&type=script&lang=js&"
import style0 from "./ExclusivesGallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports